export function getErrorDetail(error: unknown): string | undefined {
    return (error as { response?: { data?: { detail?: string } } })?.response
        ?.data?.detail;
}
